import {
    GET_ALL_TRANSACTIONS,
    GET_RECENT_TRANSACTIONS,
    SET_ALL_TRANSACTIONS,
    SET_RECENT_TRANSACTIONS
} from './actionTypes';

export const getAllTransactions = data => {
    return {
        payload: data,
        type: GET_ALL_TRANSACTIONS
    };
};

export const setAllTransactions = data => {
    return {
        payload: data,
        type: SET_ALL_TRANSACTIONS
    };
};

export const setRecentTransactions = data => {
    return {
        payload: data,
        type: SET_RECENT_TRANSACTIONS
    };
};

export const getRecentTransactions = data => {
    return {
        payload: data,
        type: GET_RECENT_TRANSACTIONS
    };
};
